import { CircularProgress, Typography, Box } from "@mui/material";

const CustomLoadingOverlay = (props) => {
  const { loadingText = "Loading. Please wait..." } = props; // Default text

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        minHeight: "100px",
        gap: 1,
      }}
    >
      <CircularProgress size={32} style={{ color: "#7152F3" }} />
      {loadingText && (
        <Typography
          sx={{
            color: "text.secondary",
            fontSize: "0.875rem",
            marginLeft: "8px",
          }}
        >
          {loadingText}
        </Typography>
      )}
    </Box>
  );
};

export default CustomLoadingOverlay;
